<div class="card">
  <div class="card-body p-3 m-2">
        <p class="p-0 m-0 d-flex align-items-center gap-1"><i class="ri-home-3-line"></i> {{ 'APARTMENT.COMMERCIAL_UNITS' | translate }} (0)</p>
    <p-table
      [value]="maintenanceContracts"
      [paginator]="false"
      [rows]="4"
      [hasEdit]="false"
      [hasView]="false"
      responsiveLayout="scroll"
      class="shadow-sm"
      tableStyleClass="table table-hover"
    >
      <ng-template pTemplate="header">
        <tr>
          <th>{{ 'APARTMENT.NO' | translate }}</th>
          <th>{{ 'PROPERTY.BUILDING_TYPE' | translate }}</th>
          <th>{{ 'METER.FLOOR' | translate }}</th>
          <th>{{ 'PROPERTY.AREA' | translate }}</th>
          <th>{{ 'CONTRACT.STATUS' | translate }}</th>
          <th>{{ 'PROPERTY.RENTER' | translate }}</th>
          <th>{{ 'READINGS.ACTIONS' | translate }}</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-maintenance>
        <tr>
          <p class="text-muted text-center">{{ 'APARTMENT.NO_RESIDENTIAL_UNITS_AVAILABLE' | translate }}</p>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
